// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateForm{box-sizing:border-box;display:flex;align-items:center;justify-content:flex-start;flex-direction:row}.DateForm .formLabel{margin-right:5px}.DateForm select{margin-top:0px;margin-right:2px}.DateForm .selectContainer{margin-right:5px}.DateForm .Button{line-height:0px;height:20px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
